import User from "./User" ;
import Lead from "./Lead" ;
import LeadStatus from "../classes/LeadStatus" ;
import DBObject from "../utils/DBObject" ;
import CloneContext from "../utils/CloneContext" ;


  export default  class  RecentCreatedLeadsRequest extends  DBObject {  private static readonly _APPLYSTATUS: number = 0 ;
  private static readonly _ISSCRAPEDDATA: number = 1 ;
  private static readonly _LEAD: number = 2 ;
  private static readonly _OFFSET: number = 3 ;
  private static readonly _PAGESIZE: number = 4 ;
  private static readonly _STATUS: number = 5 ;
  private static readonly _USER: number = 6 ;
  public id: number = 0 ;
  public otherMaster: DBObject ;
  private _isScrapedData: boolean = false ;
  private _user: User = null ;
  private _pageSize: number = 0 ;
  private _offset: number = 0 ;
  private _lead: Lead = null ;
  private _status: LeadStatus = LeadStatus.New ;
  private _applyStatus: boolean = false ;
 public constructor ( d3eParams ? : Partial<{applyStatus: boolean, isScrapedData: boolean, lead: Lead, offset: number, pageSize: number, status: LeadStatus, user: User}> ) {
 super();

this.setApplyStatus(d3eParams?.applyStatus ?? false);

this.setIsScrapedData(d3eParams?.isScrapedData ?? false);

this.setLead(d3eParams?.lead ?? null);

this.setOffset(d3eParams?.offset ?? 0);

this.setPageSize(d3eParams?.pageSize ?? 0);

this.setStatus(d3eParams?.status ?? LeadStatus.New);

this.setUser(d3eParams?.user ?? null);
 }
  public get d3eType (  ) : string {
 return 'RecentCreatedLeadsRequest' ; 
 }
  public clear (  ) : void {
 this.d3eChanges.clear();
 }
  public get isTransientModel (  ) : boolean {
 return ; 
 }
  public get isScrapedData (  ) : boolean {
 return this._isScrapedData ; 
 }
  public setIsScrapedData ( val : boolean ) : void {
 let isValChanged :boolean=this._isScrapedData !== val;

if ( !isValChanged ) {
 return ; 
 }

this.updateD3EChanges(RecentCreatedLeadsRequest._ISSCRAPEDDATA,this._isScrapedData);

this._isScrapedData=val;

this.fire('isScrapedData',this);
 }
  public get user (  ) : User {
 return this._user ; 
 }
  public setUser ( val : User ) : void {
 let isValChanged :boolean=this._user !== val;

if ( !isValChanged ) {
 return ; 
 }

this.updateD3EChanges(RecentCreatedLeadsRequest._USER,this._user);

this.updateObservable('user',this._user,val);

this._user=val;

this.fire('user',this);
 }
  public get pageSize (  ) : number {
 return this._pageSize ; 
 }
  public setPageSize ( val : number ) : void {
 let isValChanged :boolean=this._pageSize !== val;

if ( !isValChanged ) {
 return ; 
 }

this.updateD3EChanges(RecentCreatedLeadsRequest._PAGESIZE,this._pageSize);

this._pageSize=val;

this.fire('pageSize',this);
 }
  public get offset (  ) : number {
 return this._offset ; 
 }
  public setOffset ( val : number ) : void {
 let isValChanged :boolean=this._offset !== val;

if ( !isValChanged ) {
 return ; 
 }

this.updateD3EChanges(RecentCreatedLeadsRequest._OFFSET,this._offset);

this._offset=val;

this.fire('offset',this);
 }
  public get lead (  ) : Lead {
 return this._lead ; 
 }
  public setLead ( val : Lead ) : void {
 let isValChanged :boolean=this._lead !== val;

if ( !isValChanged ) {
 return ; 
 }

this.updateD3EChanges(RecentCreatedLeadsRequest._LEAD,this._lead);

this.updateObservable('lead',this._lead,val);

this._lead=val;

this.fire('lead',this);
 }
  public get status (  ) : LeadStatus {
 return this._status ; 
 }
  public setStatus ( val : LeadStatus ) : void {
 let isValChanged :boolean=this._status !== val;

if ( !isValChanged ) {
 return ; 
 }

this.updateD3EChanges(RecentCreatedLeadsRequest._STATUS,this._status.index);

this._status=val;

this.fire('status',this);
 }
  public get applyStatus (  ) : boolean {
 return this._applyStatus ; 
 }
  public setApplyStatus ( val : boolean ) : void {
 let isValChanged :boolean=this._applyStatus !== val;

if ( !isValChanged ) {
 return ; 
 }

this.updateD3EChanges(RecentCreatedLeadsRequest._APPLYSTATUS,this._applyStatus);

this._applyStatus=val;

this.fire('applyStatus',this);
 }
  public get ( field : number ) : any {
 switch ( field ) {
 case RecentCreatedLeadsRequest._ISSCRAPEDDATA : {
 return this._isScrapedData ; 
 }

case RecentCreatedLeadsRequest._USER : {
 return this._user ; 
 }

case RecentCreatedLeadsRequest._PAGESIZE : {
 return this._pageSize ; 
 }

case RecentCreatedLeadsRequest._OFFSET : {
 return this._offset ; 
 }

case RecentCreatedLeadsRequest._LEAD : {
 return this._lead ; 
 }

case RecentCreatedLeadsRequest._STATUS : {
 return this._status.index ; 
 }

case RecentCreatedLeadsRequest._APPLYSTATUS : {
 return this._applyStatus ; 
 }
 default: {
 return null ; 
 }
 }
 }
  public updateD3EChanges ( index : number,value : any ) : void {
 if ( this.lockedChanges() ) {
 return ; 
 }

super.updateD3EChanges(index,value);
 }
  public restore (  ) : void {
 /*
TODO: Might be removed
*/

this.d3eChanges.restore(this);
 }
  public deepClone ( clearId = true ) : RecentCreatedLeadsRequest {
 let ctx :CloneContext=new CloneContext({ 'clearId':clearId });

return ctx.startClone(this) ; 
 }
  public collectChildValues ( ctx : CloneContext ) : void {
  }
  public deepCloneIntoObj ( dbObj : DBObject,ctx : CloneContext ) : void {
 let obj :RecentCreatedLeadsRequest=( dbObj as RecentCreatedLeadsRequest );

obj.id=this.id;

obj.setIsScrapedData(this._isScrapedData);

obj.setUser(this._user);

obj.setPageSize(this._pageSize);

obj.setOffset(this._offset);

obj.setLead(this._lead);

obj.setStatus(this._status);

obj.setApplyStatus(this._applyStatus);
 }
  public set ( field : number,value : any ) : void {
 switch ( field ) {
 case RecentCreatedLeadsRequest._ISSCRAPEDDATA : {
 this.setIsScrapedData(( value as boolean ));
 break; }

case RecentCreatedLeadsRequest._USER : {
 this.setUser(( value as User ));
 break; }

case RecentCreatedLeadsRequest._PAGESIZE : {
 this.setPageSize(( value as number ));
 break; }

case RecentCreatedLeadsRequest._OFFSET : {
 this.setOffset(( value as number ));
 break; }

case RecentCreatedLeadsRequest._LEAD : {
 this.setLead(( value as Lead ));
 break; }

case RecentCreatedLeadsRequest._STATUS : {
 this.setStatus(LeadStatus.values [ ( value as number ) ]);
 break; }

case RecentCreatedLeadsRequest._APPLYSTATUS : {
 this.setApplyStatus(( value as boolean ));
 break; }
 }
 }
 }